import { Stack } from "@mui/material";
import { Accordion } from "@src/appV2/redesign/components/Accordion";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
} from "@src/appV2/redesign/system/ui-components";
import { useState } from "react";

export function TransferedToMeInfo() {
  const [accordionExpanded, setAccordionExpanded] = useState(true);

  return (
    <ListItem divider>
      <ListItemIcon iconType="swap-horizontal" />
      <ListItemText
        primary={
          <Accordion
            title="Transfer Request"
            expanded={accordionExpanded}
            onChange={() => {
              setAccordionExpanded(!accordionExpanded);
            }}
          >
            <Stack sx={{ px: 2 }} spacing={4}>
              <Text variant="body2">
                Accepting this transfer request is equivalent to booking the shift
              </Text>
              <Text variant="body2">
                If you accept this request and later cancel or No Call No Show, we will deduct 30
                points from the score of the professional who transfered the shift.
              </Text>

              <Text variant="body2">
                Your score will be affected as if you were booked for the shift.
              </Text>
            </Stack>
          </Accordion>
        }
      />
    </ListItem>
  );
}
